/*
 * Catalogo de permisos del sistema, agrupado por modulo.
 *
 * Vivia duplicado en AddRol y EditRol, con un state por permiso en cada archivo.
 * Cada permiso nuevo habia que agregarlo en los dos, y bastaba olvidarse de uno
 * para que la pantalla de editar no ofreciera lo que la de crear si daba.
 *
 * 'description' es la clave que viaja a la base y contra la que compara
 * isAccess(); 'label' es solo lo que se muestra.
 *
 * Al centralizarlo se corrigieron cinco defectos que arrastraba el catalogo:
 *
 *   - 'SECURITY  CREATE' se escribia con DOS espacios en AddRol, mientras el
 *     resto de la app consulta 'SECURITY CREATE'. Ningun rol creado desde esa
 *     pantalla obtenia el permiso.
 *   - 'CASHMOV DELETE' estaba repetido en el modulo de Administracion.
 *   - Faltaban 'CREAR SUCURSAL', 'EDITAR SUCURSAL', 'MIGRAR CARTERA' y
 *     'REP UTRACK': la app los consulta pero el catalogo no los ofrecia, asi
 *     que ningun rol podia tenerlos.
 *
 * Importante: isAccess() no tolera permisos ausentes (hace find(...).isEnable
 * sin verificar null), de modo que un permiso consultado y no listado aqui no
 * "deniega" sino que rompe la pantalla. Antes de consultar un permiso nuevo en
 * el codigo, agregalo a este catalogo.
 */
export const MODULES = {
	Clientes: [
		{ description: 'CLIENTS VER', label: 'Ver Clientes' },
		{ description: 'CLIENTS CREATE', label: 'Crear Clientes' },
		{ description: 'CLIENTS UPDATE', label: 'Actualizar Clientes' },
		{ description: 'CLIENTS DELETE', label: 'Eliminar Clientes' }
	],
	Créditos: [
		{ description: 'CREDITS VER', label: 'Ver Créditos' },
		{ description: 'CREDITS CREATE', label: 'Crear Créditos' },
		{ description: 'CREDITS UPDATE', label: 'Actualizar Créditos' },
		{ description: 'CREDITS REGEN', label: 'Regenerar Créditos' },
		{ description: 'CREDITS DELETE', label: 'Eliminar Créditos' },
		{ description: 'CREDIT LIQUIDATE', label: 'Liquidar Créditos' },
		{ description: 'PAYMENT UPDATE', label: 'Actualizar Plan de Pagos' },
		{ description: 'PRINT PAGARE', label: 'Imprimir Pagaré' }
	],
	Administración: [
		{ description: 'CASHMOV VER', label: 'Ver Movimientos de Caja' },
		{ description: 'CASHMOV CREATE', label: 'Crear Movimiento' },
		{ description: 'CASHMOV DELETE', label: 'Eliminar Movimiento' },
		{ description: 'CAJA VER', label: 'Ver Caja' },
		{ description: 'CAJA CREATE', label: 'Crear Caja' },
		{ description: 'ADMON VER', label: 'Ver Gastos' },
		{ description: 'ADMON CREATE', label: 'Crear Gastos' }
	],
	Reportes: [
		{ description: 'REPORTS VER', label: 'Ver Reportes' },
		{ description: 'RCLIENTS', label: 'Clientes por Gestor' },
		{ description: 'RCREDXGEST', label: 'Créditos por Gestor' },
		{ description: 'RCOBDIARIO', label: 'Cobro Diario' },
		{ description: 'RECUPERAC', label: 'Recuperación' },
		{ description: 'RDESEMBOLSO', label: 'Desembolsos' },
		{ description: 'RSALCART', label: 'Saldos de Cartera' },
		{ description: 'RCREDBARRIO', label: 'Créditos por Barrio' },
		{ description: 'RPROYINT', label: 'Proyección de Intereses' },
		{ description: 'RRECEFEC', label: 'Recuperación Efectiva' },
		{ description: 'RCREDVENC', label: 'Créditos Vencidos' },
		{ description: 'RVENCPROY', label: 'Vencimientos Proyectados' },
		{ description: 'RCREDCANC', label: 'Créditos Cancelados' },
		{ description: 'RACCOUNTSTS', label: 'Estado de Cuenta' },
		{ description: 'RBOXCLOSE', label: 'Cierre de Caja' },
		{ description: 'RRESULTSTS', label: 'Estado de Resultado' },
		{ description: 'VER UBICACIONES', label: 'Ubicaciones de Gestores' },
		{ description: 'RUTA COBRO', label: 'Ruta Óptima de Cobro' },
		{ description: 'RCOMPPAGO', label: 'Comportamiento de Pago' },
		{ description: 'RVISITAS', label: 'Cumplimiento de Visitas' },
		{ description: 'RMORAZONA', label: 'Mora por Zona' },
		{ description: 'KONAMI VER', label: 'Reporte Sin Riesgo' }
	],
	Seguridad: [
		{ description: 'SECURITY VER', label: 'Ver Seguridad' },
		{ description: 'SECURITY CREATE', label: 'Crear Seguridad' },
		{ description: 'SECURITY UPDATE', label: 'Actualizar Seguridad' },
		{ description: 'SECURITY DELETE', label: 'Eliminar Seguridad' },
		{ description: 'VER HORARIOS', label: 'Ver Horarios de Acceso' },
		{ description: 'EDITAR HORARIOS', label: 'Editar Horarios de Acceso' },
		{ description: 'MIGRAR CARTERA', label: 'Migrar Cartera' }
	],
	Configuración: [
		{ description: 'CONFIG VER', label: 'Ver Configuraciones' },
		{ description: 'CONFIG CREATE', label: 'Crear Configuraciones' },
		{ description: 'CONFIG UPDATE', label: 'Actualizar Configuraciones' },
		{ description: 'CONFIG DELETE', label: 'Eliminar Configuraciones' },
		{ description: 'CREAR SUCURSAL', label: 'Crear Sucursal' },
		{ description: 'EDITAR SUCURSAL', label: 'Editar Sucursal' }
	]
};

// Lista plana, util para inicializar el estado y para armar el payload.
export const ALL_PERMISSIONS = Object.values(MODULES).flat();
